import { Box, FormControl, Grid, Select, Typography } from "@mui/material";
import * as React from "react";
import { Query, Sort } from "../../interfaces";

interface Props {
  updateSort: (newSortField: string, newSortOrder: string) => void;
  appState: Query;
}

export default function BankFindSort({ updateSort, appState }: Props) {
  const bestMatchSort = appState.search.name || appState.search.url;
  const [sort, setSort] = React.useState<Sort>({
    sortField: bestMatchSort ? "" : "NAME",
    sortOrder: bestMatchSort ? "" : "ASC",
  });
  const sortOrderState = sort.sortOrder;
  const sortFieldState = sort.sortField;

  React.useEffect(() => {
    updateSort(bestMatchSort ? "" : "NAME", bestMatchSort ? "" : "ASC");
    setSort({
      sortField: bestMatchSort ? "" : "NAME",
      sortOrder: bestMatchSort ? "" : "ASC",
    });
  }, [bestMatchSort, updateSort]);

  const handleSortByChange = (event: any) => {
    updateSort(
      event.target.value,
      !event.target.value ? "" : sortOrderState || "ASC",
    );
    setSort({
      ...sort,
      sortField: event.target.value,
    });
  };

  const handleSortOrderChange = (event: any) => {
    updateSort(sortFieldState, event.target.value);
    setSort({
      ...sort,
      sortOrder: event.target.value,
    });
  };

  return (
    <Box
      sx={{
        "background": (theme) => theme.palette.primary.main,
        "border": "1px",
        "borderRadius": "5px",
        "height": 3,
        "padding": "16px 0.5rem",
        "& fieldset.MuiOutlinedInput-notchedOutline": {
          border: "0px !important",
        },
        "& .MuiGrid-container": {
          "height": 3,
          "marginTop": -1.5,
          "& .MuiGrid-item": {
            padding: 0,
          },
        },
      }}
    >
      <Grid container spacing={2}>
        <Grid
          size={{
            xs: 6,
            sm: 5,
            md: 4,
          }}
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontWeight: 700,
              fontSize: "14px",
              color: "#FFFFFF",
              padding: 0,
              float: "left",
              lineHeight: "24px",
            }}
          >
            Sorting:
          </Typography>
          <FormControl>
            <Select
              native
              sx={(theme) => ({
                "marginLeft": 1.25,
                "height": 3,
                "color": "#FFFFFF",
                "background": theme.palette.primary.main,
                "fontSize": 14,
                "& > .MuiNativeSelect-icon": { color: "#FFFFFF" },

                "& .MuiNativeSelect-select.MuiNativeSelect-select": {
                  "padding": "0px 32px 0px 0px",
                  "&:focus-visible": {
                    backgroundColor: "rgb(75, 118, 184)",
                  },
                },
                "& option": {
                  color: theme.palette.primary.main,
                },
              })}
              value={sortFieldState}
              name="sort"
              onChange={handleSortByChange}
              id="bankFindSortBy"
              inputProps={{ "aria-label": "sort by" }}
            >
              <option value="">Best Match</option>
              <option value="NAME">Bank Name</option>
              <option value="CERT">Cert</option>
            </Select>
          </FormControl>
        </Grid>

        <Grid
          size={{
            xs: 6,
            sm: 7,
            md: 8,
          }}
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography
            variant="body2"
            sx={
              sortFieldState !== ""
                ? {
                    fontWeight: 700,
                    fontSize: 14,
                    color: "#FFFFFF",
                    padding: 0,
                    float: "left",
                    lineHeight: "24px",
                  }
                : {
                    "fontWeight": 700,
                    "fontSize": 14,
                    "color": "#91A5C1",
                    "float": "left",
                    "lineHeight": "24px",
                    "padding": 0,
                    "& > .MuiNativeSelect-icon": { color: "#91A5C1" },
                  }
            }
          >
            Order:
          </Typography>
          <FormControl disabled={sortFieldState === ""}>
            <Select
              native
              sx={(theme) =>
                sortFieldState !== ""
                  ? {
                      "marginLeft": 1.25,
                      "height": 3,
                      "color": "#FFFFFF",
                      "background": theme.palette.primary.main,
                      "fontSize": 14,
                      "& > .MuiNativeSelect-icon": { color: "#FFFFFF" },

                      "& .MuiNativeSelect-select.MuiNativeSelect-select": {
                        "padding": "0px 32px 0px 0px",
                        "&:focus-visible": {
                          backgroundColor: "rgb(75, 118, 184)",
                        },
                      },
                      "& option": {
                        color: theme.palette.primary.main,
                      },
                    }
                  : {
                      "marginLeft": 1.25,

                      "height": 3,
                      "background": theme.palette.primary.main,

                      "fontSize": 14,
                      "& > .MuiNativeSelect-icon": { color: "#91A5C1" },
                      "& > .MuiNativeSelect-select.Mui-disabled": {
                        "opacity": 0,
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: 0,
                        },
                      },
                    }
              }
              value={sortFieldState === "" ? "" : sortOrderState}
              name="order"
              onChange={handleSortOrderChange}
              id="bankFindSortOrder"
              inputProps={{ "aria-label": "sort order" }}
            >
              <option value="ASC">Ascending</option>
              <option value="DESC">Descending</option>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
}
